import { render } from "./TagModal.vue?vue&type=template&id=1dfdba81"
import script from "./TagModal.vue?vue&type=script&lang=js"
export * from "./TagModal.vue?vue&type=script&lang=js"

import "./TagModal.vue?vue&type=style&index=0&id=1dfdba81&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__